export default __webpack_public_path__ + "static/home-header-curved-38c081a56c70876bccf66042c468716d.png";